import goTopButton from '@/components/GoTopButton'
import BaseButton from '@/components/BaseButton'
import ConfirmationDialog from '@/components/ConfirmationDialog'
import SuccessDialog from '@/components/SuccessDialog'
import ErrorDialog from '@/components/ErrorDialog'
import AddProviderDialog from './AddProviderDialog'
import EditProviderDialog from './EditProviderDialog'
import DeleteProviderDialog from './DeleteProviderDialog'
import AddMerchantDialog from './AddMerchantDialog'
import EditMerchantDialog from './EditMerchantDialog'
import DeleteMerchantDialog from './DeleteMerchantDialog'

export default {

  components: {
    goTopButton,
    BaseButton,
    ConfirmationDialog,
    SuccessDialog,
    ErrorDialog,
    AddProviderDialog,
    EditProviderDialog,
    DeleteProviderDialog,
    AddMerchantDialog,
    EditMerchantDialog,
    DeleteMerchantDialog
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      affiliate: null,
      responseErr: null,
      isProcessing: false
    }
  },

  created () {
    this.affiliate = this.$store.state.affiliates.affiliate
    if (!this.affiliate) {
      this.$store.dispatch('affiliates/invalidData', 'AFFILIATE_CONTRACT_EMPTY')
      this.$router.push({ name: 'affiliate-list' })
    }
    else {
      this.$store.dispatch('affiliates/resetInvalidData')
      this.getDetail()
    }
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },

    async getDetail () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('affiliates/resetDetail')
      await this.$store.dispatch('affiliates/detail', {
        contractId: this.affiliate.contractId,
        distributorRef: this.affiliate.distributorId,
        commercialProduct: this.affiliate.productId,
        affiliateEditMode: true
      }).then(
        () => {
          this.isProcessing = false
          this.affiliateDetail = this.$store.state.affiliates.affiliateDetail
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },
    async activate () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('affiliates/activate', {
        contractId: this.affiliateDetail.contractId,
        distributorRef: this.affiliateDetail.distributorId,
        commercialProduct: this.affiliateDetail.productId
      }).then(
        response => {
          this.isProcessing = false
          this.affiliateDetail = this.$store.state.affiliates.affiliateDetail
          this.responseErr = response.errorCode
          this.showSuccess('Activation avec succès du contrat affilié ' + this.affiliateDetail.contractId)
        },
        error => {
          this.isProcessing = false
          // this.responseErr = error.data.errorCode
          this.showError(error.data || 'BAD_REQUEST')
          this.getDetail()
        }
      )
    },
    async inactivate () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('affiliates/inactivate', {
        contractId: this.affiliateDetail.contractId,
        distributorRef: this.affiliateDetail.distributorId,
        commercialProduct: this.affiliateDetail.productId
      }).then(
        response => {
          this.isProcessing = false
          this.affiliateDetail = this.$store.state.affiliates.affiliateDetail
          this.responseErr = response.errorCode
          this.showSuccess('Inactivation avec succès du contrat affilié ' + this.affiliateDetail.contractId)
        },
        error => {
          this.isProcessing = false
          // this.responseErr = error.data.errorCode
          this.showError(error.data || 'BAD_REQUEST')
          this.getDetail()
        }
      )
    },

    async showDetails (affiliate) {
      this.$store.dispatch('affiliates/setAffiliate', affiliate)
      this.$router.push({ name: 'affiliate-detail' })
    },

    showAddProviderDialog () {
      this.$refs.addProviderDialogRef.show()
    },

    showEditProviderDialog (provider) {
      this.$refs.editProviderDialogRef.show(provider)
    },

    showDeleteProviderDialog (provider) {
      this.$refs.deleteProviderDialogRef.show(provider)
    },

    showAddMerchantDialog (provider) {
      this.$refs.addMerchantDialogRef.show(provider)
    },

    showEditMerchantDialog (provider, merchant) {
      this.$refs.editMerchantDialogRef.show(provider, merchant)
    },

    showDeleteMerchantDialog (provider, merchant) {
      this.$refs.deleteMerchantDialogRef.show(provider, merchant)
    },

    showError (msg) {
      this.$refs.errorDialogRef.showError(msg)
    },

    showSuccess (msg) {
      this.$refs.successDialogRef.showSuccess(msg)
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    }

  }
}
